import { createStyles, makeStyles } from '@material-ui/core';
import { Sizes } from '../../../../styles/sizes';

export const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      backgroundColor: 'rgba(152, 165, 183, 0.15)',
      marginTop: -23,
      borderRadius: 4,
      boxShadow: '500px 500px 0 500px rgba(152, 165, 183, 0.15)',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      paddingTop: 40,
      [theme.breakpoints.down(Sizes.mobile)]: {
        boxShadow: '0 500px 0 500px rgba(152, 165, 183, 0.15)',
        marginTop: -20,
      },
    },
    title: {
      fontSize: 28,
      fontWeight: 700,
      marginBottom: 12,
      [theme.breakpoints.down(Sizes.mobile)]: {
        fontSize: 16,
      },
    },
    subtitle: {
      opacity: 0.7,
      marginBottom: 20,
      textAlign: 'center',
      [theme.breakpoints.down(Sizes.mobile)]: {
        '& br': {
          display: 'none',
        },
      },
    },
  }),
);
